module.exports = __webpack_public_path__ + "static/media/about.9b861707.png";